import React from 'react';

export function TypingIndicator() {
  return (
    <div className="font-mono text-cyan-500">
      <div className="animate-pulse">Processing quantum data...</div>
    </div>
  );
}